import type { StoreModulePlaceholderProps } from "./store-module-placeholder.tsx";

/**
 * Store admin modules that have a route and a nav link but no implementation yet.
 *
 * One entry per unbuilt module, keyed by its route segment, driving a
 * `StoreModulePlaceholder` page. Remove an entry (and its route's use of it)
 * when the module's real screens land.
 *
 * Milestones match `docs/ecom/v1.0.1-tasks.md`.
 */
export const STORE_MODULES = {
  collections: {
    title: "Collections",
    milestone: "M6",
    summary: "Group products by season or theme — SS26, Basics, Fast-movers — to feed price lists.",
  },
  returns: {
    title: "Returns",
    milestone: "M7",
    summary:
      "Returned and damaged goods logged against an order, then restocked or written off.",
  },
  reports: {
    title: "Reports",
    milestone: "M8",
    summary:
      "Sales cut by month, category, buyer and product, plus order book, discount impact and returns.",
  },
} as const satisfies Record<string, StoreModulePlaceholderProps>;
